import * as React from 'react';
import classNames from 'classnames';

export interface FormHelperTextProps {
  text: React.ReactNode | string;
  helperTextId?: string;
  hasError?: boolean;
  as?: keyof JSX.IntrinsicElements;
  align?: 'left' | 'right';
  style?: 'italic';
}

const FormHelperText: React.FC<FormHelperTextProps> = (
  props: FormHelperTextProps
) => {
  const {
    text,
    hasError,
    helperTextId,
    as: Component = 'p',
    align,
    style,
  } = props;
  const helperClasses = classNames(
    'ui-form-helper-text',
    `ui-form-helper-text--align-${align}`,
    {
      'ui-form-helper-text--error': hasError,
      [`ui-form-helper-text--style-${style}`]: style,
    }
  );

  return (
    <Component className={helperClasses} id={helperTextId}>
      {text}
    </Component>
  );
};

export default FormHelperText;
